import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ErrorFragment = { field: string, messages: Array<string> };

export const ErrorFragmentDoc = gql`
    fragment Error on ErrorType {
  field
  messages
}
    `;